import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import * as en from "./en";
import * as ko from "./ko";
import * as ja from "./ja";

const langCd = localStorage.getItem("langCd") || "ko";

const resources: Resource = {
  en: {
    translation: {
      ...en.default,
    },
  },
  ko: {
    translation: {
      ...ko.default,
    },
  },
  ja: {
    translation: {
      ...ja.default,
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: langCd,
  fallbackLng: "ko",
  defaultNS: "translation", // 기본 네임스페이스 지정
  interpolation: {
    escapeValue: false, // React는 XSS 방지됨
  },
});

export default i18n;
